import login1 from '/public/siteImages/iOSTheme/loginPage/theme1/login1.png';
import login2 from '/public/siteImages/iOSTheme/loginPage/theme1/login2.png';
import login3 from '/public/siteImages/iOSTheme/loginPage/theme2/login3.png';
import login4 from '/public/siteImages/iOSTheme/loginPage/theme2/login4.png';
import login5 from '/public/siteImages/iOSTheme/loginPage/theme3/login5.png';
import login6 from '/public/siteImages/iOSTheme/loginPage/theme3/login6.png';
import login7 from '/public/siteImages/iOSTheme/loginPage/theme4/login7.png';
import login8 from '/public/siteImages/iOSTheme/loginPage/theme4/login8.png';
import login9 from '/public/siteImages/iOSTheme/loginPage/theme4/login9.png';
import login10 from '/public/siteImages/iOSTheme/loginPage/theme4/login10.png';

export{
    login1,
    login2,
    login3,
    login4,
    login5,
    login6,
    login7,
    login8,
    login9,
    login10,
}

